module.exports = __webpack_public_path__ + "img/Usr-iot.bd5aedef.jpg";